export default __webpack_public_path__ + "static/media/reward-program-points-subdued.629464da.svg";